import NormalIcon from '../StockItems/NormalIcon';

function App(props) {

  var changeTab = props.changeTab;
  var tabSelected = props.tabSelected;
  var options = props.options;

  var selectTab = tabSelected.s;
  function setSelectTab(tabNos){
    changeTab(tabSelected.t, tabNos);
  }

  function clickSelectTab(nos){
    return function(e){
      setSelectTab(-1);
      setTimeout(function(){ setSelectTab(nos); }, 0);
    }
  }

  return options.map((anOption, index)=>{
    var isBrightWhenLit = true;
    var className = '';
    var s = {}
    if (+index === selectTab){
      isBrightWhenLit = false;
      className = 'normalIconSelected';
    }else{
      if (anOption.e){
        s.color = 'red';
      }
    }
    return <NormalIcon icon={anOption.i} title={anOption.n} style={s} isBrightWhenLit={isBrightWhenLit} className={className} height='30px' onClick = {clickSelectTab(+index)} />
  })


}

export default App;
